import { createTheme, ThemeOptions } from "@mui/material/styles";
import colors from "./colors";
import typography from "./typography";

const lightTheme: ThemeOptions = createTheme({
  palette: {
    primary: {
      main: colors.light.primary.blue,
      light: colors.light.primary.light,
      dark: colors.light.primary.blue100,
      contrastText: colors.light.white.full,
    },
    secondary: {
      main: colors.light.primary.orange,
    },
    background: {
      default: colors.light.primary.background,
      paper: colors.light.primary.background,
    },
    text: {
      primary: colors.light.black.full,
      secondary: colors.light.black.light80,
      disabled: colors.light.black.light40,
    },
    error: {
      main: colors.light.semantic.error,
    },
    warning: {
      main: colors.light.semantic.warning,
    },
    success: {
      main: colors.light.semantic.success,
    },
    info: {
      main: colors.light.semantic.information,
    },
    divider: colors.light.greys[300]
  },
  typography,
  spacing: (factor: number) => `${0.25 * factor}rem`, // 4px scale
  shape: {
    borderRadius: 4,
  },
  // shadows: Array(25).fill("none") as string[], // Minimal shadows for flat design
});

export default lightTheme;
